import Vue from "vue";

export default {
  setList(state, list) {
    Vue.set(state, "subList", list);
  },

  setTotal(state, total) {
    Vue.set(state, "total", total);
  },

  setTotalActive(state, total) {
    Vue.set(state, "totalActive", total);
  },

  updateSortby(state, sortby) {
    Vue.set(state, "sortby", sortby);
  },

  updateSortdir(state, sortdir) {
    Vue.set(state, "sortdir", sortdir);
  },

  updateOrderby(state, orderby) {
    Vue.set(state, "orderby", orderby);
  },

  updateTerm(state, term) {
    Vue.set(state, "term", term);
  },

  setStatus(state, payload) {
    Vue.set(payload.sub, "account_status", payload.status);
  },

  addToList(state, results) {
    const newList = [...state.subList, ...results];
    Vue.set(state, "subList", newList);
  },

  addPage(state) {
    Vue.set(state, "page", state.page + 1);
  },

  resetPage(state) {
    Vue.set(state, "page", 1);
  },

  setCanceledToken(state, sub) {
    const arr = state.subList.filter(s => {
      if (s.id === sub.sub.id) {
        return true;
      }
      return false;
    });
    Vue.set(arr[0], "token", "no-token-canceled");
  },

  showModal(state, sub) {
    Vue.set(state, "modalShow", true);
    Vue.set(state, "modalSub", sub);
  },

  hideModal(state) {
    Vue.set(state, "modalShow", false);
  },

  setNextPayment(state, payload) {
    const sub = state.subList.filter(s => {
      if (s.id === payload.subId) {
        return true;
      }
      return false;
    });

    const date = new Date(sub[0].sub_next_payment);

    if (payload.durationType === "days") {
      date.setDate(date.getDate() + parseInt(payload.duration));
    } else {
      date.setMonth(date.getMonth() + parseInt(payload.duration));
    }

    Vue.set(sub[0], "sub_next_payment", date);
  },

  chargeMessage(state, payload) {
    Vue.set(state, "notificationText", payload.message);
    Vue.set(state, "notificationShow", true);
  },

  hideMessage(state) {
    Vue.set(state, "notificationShow", false);
    Vue.set(state, "notificationText", "");
  },

  setRefList(state, list) {
    Vue.set(state, "refList", list);
  },

  setRefNotActive(state, id) {
    const filtered = state.refList.filter(r => {
      if (r.id === id) {
        return true;
      }
      return false;
    });

    Vue.set(filtered[0], "active", 0);
  },

  setRefActive(state, id) {
    const filtered = state.refList.filter(r => {
      if (r.id === id) {
        return true;
      }
      return false;
    });

    Vue.set(filtered[0], "active", 1);
  },

  openNewRef(state) {
    Vue.set(state.newRef, "open", !state.newRef.open);
  },

  setNewRef(state, ref) {
    state.refList.push(ref);
  },

  setCurrentRef(state, ref) {
    Vue.set(state, "currentRef", ref);
  },

  setCupons(state, cupons) {
    Vue.set(state, "cupons", cupons);
  },

  toggleCuponForm(state) {
    Vue.set(state.cuponForm, "open", !state.cuponForm.open);
  },

  newCuponForm(state) {
    Vue.set(state.cuponForm, "mode", "new");
  },

  resetCuponForm(state) {
    const obj = {
      open: false,
      mode: "",
      cupon: "",
      free_days: "",
      qty: "",
      valid_until: "",
      company: ""
    };
    Vue.set(state, "cuponForm", obj);
  },

  updateCupon(state, cupon) {
    cupon.cupon_id = cupon.id;
    Vue.set(state, "cuponForm", cupon);
    // Vue.set(state.cuponForm, 'cupon', cupon.cupon);
    // Vue.set(state.cuponForm, 'days', cupon.free_days);
    // Vue.set(state.cuponForm, 'qty', cupon.qty);
    // Vue.set(state.cuponForm, 'validUntil', cupon.valid_until);
  },

  addToCuponList(state, cupon) {
    state.cupons.push(cupon);
  },

  updateCuponList(state, cupon) {
    const filtered = state.cupons.filter(c => {
      if (c.id === cupon.id) {
        return true;
      }
      return false;
    });

    Vue.set(filtered[0], "cupon", cupon.cupon);
    Vue.set(filtered[0], "qty", cupon.qty);
    Vue.set(filtered[0], "free_days", cupon.free_days);
    Vue.set(filtered[0], "valid_until", cupon.valid_until);
  },

  redmoveCupon(state, index) {
    state.cupons.splice(index, 1);
  },

  cuponError(state) {
    Vue.set(state.cuponForm, "error", true);
  },

  setCuponUsers(state, list) {
    Vue.set(state, "cuponUsers", list);
  },

  setStats(state, stats) {
    Vue.set(state, "stats", stats);
  },
  setStatsLoading(state, bool) {
    Vue.set(state.stats, "loading", bool);
  }
};
